export const config = {
    api_base: 'https://in-prod.diningtek.com/api/v1',
    api_root : 'https://in-prod.diningtek.com',
    logo_img_root : '/img/tandoori-new-logo.png',
    banner_img_root : '/img/tandoori-banner5.jpg',
    resid : '',
    key_value : 'diningtek_yDrlcdneFmPYyJOUoPUDSgGqLTdUjdFaUzFRwBlQfqCijWMkxq',
    secret_value : 'ZDBXXVXZXvJMZIdVItQmutURzSkfptKHkVyzaGKmlsuWpZKgxDbQtFdFImTTTTHVFViXAqfeIWStdDvqmEyzoujsSuEHZeOnSAsEseMvYfsYpSAOuEDwnAXkAadsImVWDBmAFDwtriHHFjtfyurHlQSvhdGfrmGPyYebRLedrUJvdIQzxScVPIRwDfFvVuPIHHPyBhvx',
    iframe_root : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3057.09091660424!2d-105.25189743511967!3d39.98407353976348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876bed09fb8ab873%3A0x5cde0bdf05141db2!2sTandoori%20Grill!5e0!3m2!1sen!2sin!4v1583987491558!5m2!1sen!2sin',
    facebook_link:'#',
    RestaurantName:"DiningTek",
    site_key : '6LdhdNgUAAAAABk8kk7tJYXOj-6sCzUZ1FXpus9l',
    secret_key : '6LdhdNgUAAAAAG_8exdGndAHVLt-nJZN7U8kz_yS'
};
